export const getNativeInterface = () => window.MyInterface;

export const requestJavaVersion = () => window.MyInterface?.obtenerJavaVersion?.();
export const requestSerialNumber = () => window.MyInterface?.obtenerSerialClover?.();
export const setStatusBarColor = color => window.MyInterface?.changeStatusBarColor?.(color) ?? window.MyInterface?.changeStatusBarColor?.("#FFE600");
export const printAfipReceipt = base64Data => window.MyInterface.imprimirComprobanteMercadoPago(base64Data);
export const scanProduct = () => window.MyInterface.scanMercadoPago();
export const startPaymentMercadoPago = (amount, mode, cuotas) =>
  window.MyInterface.startPaymentMercadoPago(amount, mode, cuotas);
export const scanMercadoPago = () => window.MyInterface.scanMercadoPago();
export const obtenerCollectorId = () => window.MyInterface.obtenerCollectorId();
export const imprimirComprobanteMercadoPago = base64Data =>
  window.MyInterface.imprimirComprobanteMercadoPago(base64Data);

export default {
  getNativeInterface,
  requestJavaVersion,
  requestSerialNumber,
  setStatusBarColor,
  printAfipReceipt,
  scanProduct,
  startPaymentMercadoPago,
  scanMercadoPago,
  obtenerCollectorId,
  imprimirComprobanteMercadoPago,
};
